// Focus auf Sprungmarke setzen
document.addEventListener('DOMContentLoaded', function() {
    const cType = document.getElementById('contentWrapperNewsDetail').dataset.ctype;
    const uId = document.getElementById('contentWrapperNewsDetail').dataset.uid;

    // News-Detail-Header löschen
    $('div#c'+uId+' > div.bund-text-margin-bottom').remove();
});
